<script setup>
import { computed } from 'vue';

import contributorLevelOneBadge from '@images/contributor-level-1.svg';
import contributorLevelTwoBadge from '@images/contributor-level-2.svg';
import contributorLevelThreeBadge from '@images/contributor-level-3.svg';
import contributorLevelFourBadge from '@images/contributor-level-4.svg';
import contributorLevelFiveBadge from '@images/contributor-level-5.svg';
import coreTeamBadge from '@images/core-team.svg';
import teamMemberBadge from '@images/team-member.svg';

const props = defineProps({
  badgeSize: {
    type: Number,
    default: 40,
  },
  contributorLevel: {
    type: Number,
    default: 0,
  },
  teamMember: {
    type: Boolean,
    default: false,
  },
  coreTeam: {
    type: Boolean,
    default: false,
  },
});

const contributorLevelBadge = {
  1: contributorLevelOneBadge,
  2: contributorLevelTwoBadge,
  3: contributorLevelThreeBadge,
  4: contributorLevelFourBadge,
  5: contributorLevelFiveBadge,
};

const badgeSrc = computed(() => {
  if (props.teamMember) {
    return teamMemberBadge;
  }

  if (props.coreTeam) {
    return coreTeamBadge;
  }

  if (Object.keys(contributorLevelBadge).includes(props.contributorLevel.toString())) {
    return contributorLevelBadge[props.contributorLevel];
  }

  return null;
});

const badgeTitle = computed(() => {
  if (props.teamMember) {
    return 'Team Member badge';
  }

  if (props.coreTeam) {
    return 'Core Team badge';
  }

  return `Contributor level ${props.contributorLevel} badge`;
});

const hasBadge = computed(() => badgeSrc.value != null);
</script>

<template>
  <img
    v-if="hasBadge"
    :src="badgeSrc"
    :height="props.badgeSize"
    :width="props.badgeSize"
    :alt="badgeTitle"
    :title="badgeTitle"
  >
</template>
